export default [
    {
        icon: 'GridIcon',
        route: 'op',
        title: 'Op'
    },
]
